import styled from "styled-components";

import food from "../../assets/food.jpg";

interface IContainer {
    imgSrc?: string;
    disabledImg?: boolean;
    inActiveHeader?: boolean;
}

const BackImgContainer = styled.div<IContainer>`
    height: ${(props) => (props.inActiveHeader ? "90%" : "82%")};
    background-image: ${(props) => (props.disabledImg ? "" : `url(${food})`)};
    background-repeat: no-repeat;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    display: flex;
    justify-content: center;
    padding: 1vw;

    @media (max-width: 1000px) {
        align-items: center;
    }
`;

const WhiteTableContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2vw;
    background-color: white;
    height: 60%;
    overflow-x: hidden;

    @media (max-height: 667px) {
        overflow-y: scroll;
    }
`;

const GridContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background-color: white;
    height: 100%;
`;

const TransparentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
`;

const ScrollContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow: scroll;
    width: 100vw;
    height: 75%;
`;

export {
    BackImgContainer,
    WhiteTableContainer,
    ScrollContainer,
    GridContainer,
    TransparentContainer,
};
